import React from "react";
import Layout from "../components/Layout";
import MintedSales from "../components/_RedeemAtPVC";
import EcomRedeemAtPVC from "../components/_RedeemAtPVC";

const RedeemAtPVC = (props:any) => {
    return (
    <Layout>
        <EcomRedeemAtPVC />
    </Layout>
    )
}

export default RedeemAtPVC